module.exports = __webpack_public_path__ + "static/media/play-shooting-failed.d61ebbe4.mp3";